import React, { useEffect, useCallback } from 'react';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Collapse } from 'reactstrap';
import navdata from "../LayoutMenuData";
import { withTranslation } from "react-i18next";
import withRouter from "../../Components/Common/Velzon/withRouter";
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import { getEffectiveUser } from 'helpers/impersonation_helper';
import { userRoles } from 'common/user_roles';

const VerticalLayout = (props: any) => {
    const navData = navdata().props.children;
    const path = props.router.location.pathname;
    const userLogged = getEffectiveUser();

    const userRolesArray = Array.isArray(userLogged.role) ? userLogged.role : [userLogged.role];

    const roleMap: Record<string, string> = userRoles.reduce((acc: any, role) => {
        acc[role.value] = role.label;
        return acc;
    }, {});

    const hasAccess = (allowedRoles: string[] | undefined) => {
        if (!allowedRoles) return true; // Si no hay roles definidos, todos tienen acceso

        // Verificar si ALGÚN rol del usuario está en los roles permitidos
        return userRolesArray.some((userRole: any) => {
            const userRoleValue = userRole;
            const userRoleLabel = roleMap[userRoleValue] || userRoleValue;

            return allowedRoles.includes(userRoleValue) ||
                allowedRoles.includes(userRoleLabel);
        });
    };

    // 🔥 Nuevo filtro con soporte para múltiples roles
    const filterMenuItems = (items: any[]) => {
        return items
            .map((item) => {
                const allowed = hasAccess(item.roles);

                if (!allowed) return null;

                // clon limpio
                const newItem = { ...item };

                if (newItem.subItems) {
                    newItem.subItems = filterMenuItems(newItem.subItems);
                }

                if (newItem.childItems) {
                    newItem.childItems = filterMenuItems(newItem.childItems);
                }

                return newItem;
            })
            .filter(Boolean);
    };

    const visibleMenuItems = filterMenuItems(navData);

    /*
    layout settings
    */
    const selectLayoutState = (state: any) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            leftsidbarSizeType: layout.leftsidbarSizeType,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
            layoutType: layout.layoutType
        })
    );

    const {
        leftsidbarSizeType, sidebarVisibilitytype, layoutType
    } = useSelector(selectLayoutProperties);

    //vertical and semibox resize events
    const resizeSidebarMenu = useCallback(() => {
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        var hamburgerIcon = document.querySelector(".hamburger-icon");

        if (windowSize >= 1025) {
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }
            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }
            if ((sidebarVisibilitytype === "show" || layoutType === "vertical" || layoutType === "twocolumn") && document.querySelector(".hamburger-icon")) {
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.add("open");
                }
            } else {
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.remove("open");
                }
            }
        } else if (windowSize < 1025 && windowSize > 767) {
            document.body.classList.remove("twocolumn-panel");
            document.body.classList.remove("vertical-sidebar-enable");
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", "lg");
            }
            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", "lg");
            }
            // sidebar starts hidden on tablet → icon shows "open" (3 lines)
            if (humberIcon) {
                humberIcon.classList.remove("open");
            }
        } else if (windowSize <= 767) {
            document.body.classList.remove("vertical-sidebar-enable");
            if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
                document.documentElement.setAttribute("data-sidebar-size", "lg");
            }
            // sidebar starts hidden on mobile → icon shows "open" (3 lines)
            if (humberIcon) {
                humberIcon.classList.remove("open");
            }
        }
    }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

    useEffect(() => {
        resizeSidebarMenu();
        window.addEventListener("resize", resizeSidebarMenu, true);
        return () => window.removeEventListener("resize", resizeSidebarMenu, true);
    }, [resizeSidebarMenu]);

    useEffect(() => {
        if (document.body.classList.contains('vertical-sidebar-enable')) {
            document.body.classList.remove('vertical-sidebar-enable');
            const humberIcon = document.querySelector('.hamburger-icon');
            if (humberIcon) humberIcon.classList.remove('open');
        }
    }, [path]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + path;
            const ul = document.getElementById("navbar-nav") as HTMLElement;
            const items: any = ul.getElementsByTagName("a");
            let itemsArray = [...items];
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                return x.pathname === pathName;
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        if (props.layoutType === "vertical") {
            initMenu();
        }
    }, [path, props.layoutType]);

    function activateParentDropdown(item: any) {
        item.classList.add("active");
        let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {
            parentCollapseDiv.classList.add("show");
            parentCollapseDiv.parentElement.children[0].classList.add("active");
            parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
                }
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items: any) => {
        let actiItems = items.filter((x: any) => x.classList.contains("active"));

        actiItems.forEach((item: any) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };

    return (
        <React.Fragment>
            {(visibleMenuItems || []).map((item: any, key: number) => {
                return (
                    <React.Fragment key={key}>
                        {item['isHeader'] ?
                            <li className="menu-title">
                                <span data-key="t-menu">{props.t(item.label)}</span>
                            </li>
                            : (
                                (item.subItems ? (
                                    <li className="nav-item">
                                        <Link
                                            onClick={item.click}
                                            className="nav-link menu-link"
                                            to={item.link ? item.link : "/#"}
                                            data-bs-toggle="collapse"
                                        >
                                            <i className={item.icon}></i>
                                            <span data-key="t-apps">{props.t(item.label)}</span>
                                            {item.badgeName ?
                                                <span className={"badge badge-pill bg-" + item.badgeColor} data-key="t-new">{item.badgeName}</span>
                                                : null}
                                        </Link>
                                        <Collapse
                                            className="menu-dropdown"
                                            isOpen={item.stateVariables}
                                            id="sidebarApps"
                                        >
                                            <ul className="nav nav-sm flex-column">
                                                {item.subItems?.map((subItem: any, key: number) => (
                                                    <React.Fragment key={key}>
                                                        {!subItem.isChildItem ? (
                                                            <li className="nav-item">
                                                                <Link
                                                                    to={subItem.link ? subItem.link : "/#"}
                                                                    className="nav-link"
                                                                >
                                                                    {props.t(subItem.label)}
                                                                    {subItem.badgeName ?
                                                                        <span className={"badge badge-pill bg-" + subItem.badgeColor}></span>
                                                                        : null}
                                                                </Link>
                                                            </li>
                                                        ) : (
                                                            <li className="nav-item">
                                                                <Link
                                                                    onClick={subItem.click}
                                                                    className="nav-link"
                                                                    to="/#"
                                                                    data-bs-toggle="collapse"
                                                                >
                                                                    {props.t(subItem.label)}
                                                                </Link>
                                                                <Collapse
                                                                    className="menu-dropdown"
                                                                    isOpen={subItem.stateVariables}
                                                                >
                                                                    <ul className="nav nav-sm flex-column">
                                                                        {subItem.childItems?.map((childItem: any, key: number) => (
                                                                            <li className="nav-item" key={key}>
                                                                                <Link
                                                                                    to={childItem.link ? childItem.link : "/#"}
                                                                                    className="nav-link"
                                                                                >
                                                                                    {props.t(childItem.label)}
                                                                                </Link>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </Collapse>
                                                            </li>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </ul>
                                        </Collapse>
                                    </li>
                                ) : (
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={item.link ? item.link : "/#"}>
                                            <i className={item.icon}></i>
                                            <span>{props.t(item.label)}</span>
                                        </Link>
                                    </li>
                                ))
                            )}
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};

VerticalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));